import { Component, OnInit, Type } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
interface INgSelectType extends FormlyFieldProps {
  multiple?: any;
}

@Component({
  selector: 'app-ng-select',
  templateUrl: './ng-select-type.component.html',
  styleUrls: ['./ng-select-type.component.scss'],
})
export class NgSelectTypeComponent  extends FieldType<FieldTypeConfig<any>> {
  
  addTagFn(value) {
    return { value: value, label: value, tag: true };
  }
}
